import React, {useEffect, useMemo, useState} from 'react'
import { getCurrentUser } from '../utils/auth'
import {format} from 'date-fns'
import "./Clients.css"
import { useNavigate } from "react-router-dom"
import { BsFillPencilFill, BsFillTrashFill, BsFileTextFill, BsTable } from 'react-icons/bs'
import ModalWide from "./ModalWide"
import ModalSessions from './ModalSessions'
import ModalNotes from './ModalNotes'
import ModalDeactivateClient from './ModalDeactivateClient'
import Caret from './Icon/Caret'
import { Link } from 'react-router-dom'

const Clients = ({deleteRow,clientSessions}) => {
    const tokenPayload = getCurrentUser() || {};
    const userScopes = tokenPayload.scopes || [];
    const currentUserTypeId = Number(tokenPayload?.user_type_id ?? tokenPayload?.user_type);
    const canShowCustomerFilter = currentUserTypeId === 9 || currentUserTypeId === 10;
    const navigate = useNavigate();
    const permissionScope = 'clientData'
    const tokenCustomerId = tokenPayload?.customer ?? tokenPayload?.customer_id;
    const hasGlobalReadPermission = userScopes.includes('read:' + permissionScope);
    const hasCustomerScopedReadPermission = userScopes.some((scope) => scope.startsWith('read:' + permissionScope + 'Customer'));
    const hasReadPermission = hasGlobalReadPermission || hasCustomerScopedReadPermission;
    const shouldFilterByCustomer = Boolean(tokenCustomerId !== undefined && tokenCustomerId !== null && hasCustomerScopedReadPermission && !hasGlobalReadPermission);
    const fetchAllClientsUrl = process.env.REACT_APP_API_URL_BASE + '/clients/view'
    const fetchSingleClientUrl = process.env.REACT_APP_API_URL_BASE + '/clients/client/*id*/view'
    const fetchCustomerClientDataUrl = process.env.REACT_APP_API_URL_BASE + '/clients/customer/*id*/view'
    const fetchSingleCustomerDataUrl = process.env.REACT_APP_API_URL_BASE + '/customers/customer/*id*'
    const fetchAllCustomersUrl = process.env.REACT_APP_API_URL_BASE + '/customers/view'
    const fieldsNoSort = ["Info", "Pin", "Steady Only", "Actions"]
    const headers = [
        {
            id: 1,
            KEY: "info",
            LABEL: "Info",
            CLASS: "icons-width"
        },
        {
            id: 2,
            KEY: "first_name",
            LABEL: "First Name",
            CLASS: "left"
        },
        {
            id: 3,
            KEY: "last_name",
            LABEL: "Last Name",
            CLASS: "left"
        },
        {
            id: 4,
            KEY: "mobile",
            LABEL: "Mobile",
            CLASS: "left"
        },
        {
            id: 5,
            KEY: "pin",
            LABEL: "Pin",
            CLASS: ""
        },
        {
            id: 6,
            KEY: "customer_display",
            LABEL: "Customer",
            CLASS: "center"
        },
        {
            id: 7,
            KEY: "is_active",
            LABEL: "Active",
            CLASS: ""
        },
        {
            id: 8,
            KEY: "steady_only",
            LABEL: "Steady Only",
            CLASS: ""
        },
        {
            id: 9,
            KEY: "last_updated",
            LABEL: "Last Updated",
            CLASS: "left"
        },
        {
            id: 10,
            KEY: "created_on",
            LABEL: "Created On",
            CLASS: "left"
        },
        {
            id: 11,
            KEY: "actions",
            LABEL: "Actions",
            CLASS: "left"
        }
    ]

    const [clientEdit, setClientEdit] = useState(null);
    const [clientIdSessions, setClientIdSessions] = useState(null);
    const [clientInfo, setClientInfo] = useState(null);
    const [customerInfo, setCustomerInfo] = useState(null);
    const [editedRecord, setEditedRecord] = useState(null);
    const [isNewClient, setIsNewClient] = useState(false);
    const [modalNotes, setModalNotes] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [isReadOnlyModal, setIsReadOnlyModal] = useState(false);
    const [modalSessionsOpen, setModalSessionsOpen] = useState(false);
    const [sessionsReturnContext, setSessionsReturnContext] = useState(null);
    const [modalDeactivateOpen, setModalDeactivateOpen] = useState(false);
    const [deactivateClientInfo, setDeactivateClientInfo] = useState(null);
    const [deactivateRecordIndex, setDeactivateRecordIndex] = useState(null);
    const [isDeactivating, setIsDeactivating] = useState(false);
    const [records, setRecords] = useState([]);
    const [isTableLoading, setIsTableLoading] = useState(true);
    const [showActive, setShowActive] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [selectedCustomerFilter, setSelectedCustomerFilter] = useState('all');
    const [activeCustomerNames, setActiveCustomerNames] = useState([]);
    const [hasLoadedActiveCustomerNames, setHasLoadedActiveCustomerNames] = useState(false);
    const [sort, setSort] = useState({ keyToSort: "last_name", direction: "asc"});

    const normalizedSearchText = searchText.trim().toLowerCase();

    const getCustomerDisplayFromRecord = (record) => {
        const customersValue = record?.customers;

        if (Array.isArray(customersValue)) {
            return customersValue
                .map((customer) => {
                    if (typeof customer === 'string') {
                        return customer;
                    }

                    if (customer && typeof customer === 'object') {
                        return customer.customer_name ?? customer.name ?? customer.description ?? '';
                    }

                    return '';
                })
                .filter((name) => String(name).trim() !== '')
                .join(', ');
        }

        if (customersValue && typeof customersValue === 'object') {
            return customersValue.customer_name ?? customersValue.name ?? customersValue.description ?? '';
        }

        if (typeof customersValue === 'string') {
            return customersValue;
        }

        return record?.customer_name ?? '';
    };

    const getCustomerNamesFromRecord = (record) => {
        const customersValue = record?.customers;

        if (Array.isArray(customersValue)) {
            return customersValue
                .map((customer) => {
                    if (typeof customer === 'string') {
                        return customer;
                    }

                    if (customer && typeof customer === 'object') {
                        return customer.customer_name ?? customer.name ?? customer.description ?? '';
                    }

                    return '';
                })
                .map((name) => String(name ?? '').trim())
                .filter((name) => name !== '');
        }

        if (customersValue && typeof customersValue === 'object') {
            const objectName = String(customersValue.customer_name ?? customersValue.name ?? customersValue.description ?? '').trim();
            return objectName ? [objectName] : [];
        }

        if (typeof customersValue === 'string') {
            const raw = String(customersValue).trim();
            return raw ? [raw] : [];
        }

        const fallbackName = String(record?.customer_name ?? '').trim();
        return fallbackName ? [fallbackName] : [];
    };

    const activeCustomerNameSet = useMemo(() => {
        return new Set(activeCustomerNames.map((name) => String(name).trim().toLowerCase()));
    }, [activeCustomerNames]);

    const mapClientRecord = (record) => ({
        ...record,
        customer_display: getCustomerDisplayFromRecord(record),
    });

    const customerFilterOptions = useMemo(() => {
        const uniqueNames = Array.from(
            new Set(
                records
                    .flatMap((record) => getCustomerNamesFromRecord(record))
                    .map((name) => String(name).trim())
                    .filter((name) => name !== '')
            )
        )
            .filter((name) => {
                if (!hasLoadedActiveCustomerNames) {
                    return true;
                }

                return activeCustomerNameSet.has(String(name).trim().toLowerCase());
            })
            .sort((a, b) => a.localeCompare(b));

        return [
            { value: 'all', label: 'All' },
            ...uniqueNames.map((name) => ({ value: name, label: name })),
        ];
    }, [activeCustomerNameSet, hasLoadedActiveCustomerNames, records]);

    useEffect(() => {
        if (selectedCustomerFilter === 'all') {
            return;
        }

        const hasSelectedCustomer = customerFilterOptions.some((option) => option.value === selectedCustomerFilter);
        if (!hasSelectedCustomer) {
            setSelectedCustomerFilter('all');
        }
    }, [customerFilterOptions, selectedCustomerFilter]);

    const matchesCustomerFilter = (record) => {
        if (selectedCustomerFilter === 'all') {
            return true;
        }

        const selectedValue = String(selectedCustomerFilter).trim().toLowerCase();
        return getCustomerNamesFromRecord(record)
            .some((customerName) => String(customerName).trim().toLowerCase() === selectedValue);
    };

    const matchesSearch = (record) => {
        if (!normalizedSearchText) {
            return true;
        }

        const searchableValues = [
            record.first_name,
            record.last_name,
            record.mobile,
            record.email,
            record.pin,
            record.customer_display,
        ];

        return searchableValues
            .filter((value) => value !== null && value !== undefined)
            .some((value) => String(value).toLowerCase().includes(normalizedSearchText));
    };

    const visibleRecords = records
        .map((record, recordIndex) => ({ record, recordIndex }))
        .filter(({ record }) => (showActive || record.is_active !== false) && matchesCustomerFilter(record) && matchesSearch(record));


    const fetchAllClientData = async () => {
        setIsTableLoading(true);
        try{
            const response = await fetch(fetchAllClientsUrl,
                {
                    method: 'GET',
                    headers: {
                        'machine':'2',
                        'vh-key':'7df7f81e-aaff-444c-a01c-8caeaeab3e61',
                    },
                });
            if (!response.ok) {
                throw new Error(`Fetch error - ${response.url} - Status: ${response.status}`);
            }
            const json = await response.json();
            setRecords(Array.isArray(json) ? json.map(mapClientRecord) : []);
        } catch (error) {
            console.error(error);
        } finally {
            setIsTableLoading(false);
        }
    }

    const fetchSingleClientData = async (client_id) => {
        try{
            const response = await fetch(fetchSingleClientUrl.replace("*id*", client_id),
                {
                    method: 'GET',
                    headers: {
                        'machine':'2',
                        'vh-key':'7df7f81e-aaff-444c-a01c-8caeaeab3e61',
                    },
                });
            if (!response.ok) {
                throw new Error(`Fetch error - ${response.url} - Status: ${response.status}`);
            }
            const json = await response.json();
            setRecords(originalRecords => {
                const newRecords = [...originalRecords];
                newRecords[editedRecord] = mapClientRecord(json[0]);
                return newRecords;
            });
        } catch (error) {
            console.error(error);
        }
    }

    const fetchCustomerClientData = async () => {
        setIsTableLoading(true);
        try {
            const response = await fetch(fetchCustomerClientDataUrl.replace("*id*", tokenCustomerId),
                {
                    method: 'GET',
                    headers: {
                        'machine':'2',
                        'vh-key':'7df7f81e-aaff-444c-a01c-8caeaeab3e61',
                    },
                });
            if (!response.ok) {
                throw new Error(`Fetch error - ${response.url} - Status: ${response.status}`);
            }
            const json = await response.json();
            setRecords(Array.isArray(json) ? json.map(mapClientRecord) : []);
        } catch (error) {
            console.error(error);
        } finally {
            setIsTableLoading(false);
        }
    }

    const fetchCustomerData = async () => {
        const response = await fetch(fetchSingleCustomerDataUrl.replace("*id*",tokenCustomerId),
            {
                method: 'GET',
                headers: {
                    'machine':'2',
                    'vh-key':'7df7f81e-aaff-444c-a01c-8caeaeab3e61',
                },
            });
            const json = await response.json();
            setCustomerInfo(json[0]);
    }

    const fetchActiveCustomerNames = async () => {
        try {
            const response = await fetch(fetchAllCustomersUrl,
                {
                    method: 'GET',
                    headers: {
                        'machine':'2',
                        'vh-key':'7df7f81e-aaff-444c-a01c-8caeaeab3e61',
                    },
                });

            if (!response.ok) {
                throw new Error(`Fetch error - ${response.url} - Status: ${response.status}`);
            }

            const json = await response.json();
            const activeNames = Array.isArray(json)
                ? json
                    .filter((customer) => customer?.is_active === true)
                    .map((customer) => String(customer?.customer_name ?? customer?.name ?? customer?.description ?? '').trim())
                    .filter((name) => name !== '')
                : [];

            setActiveCustomerNames(activeNames);
            setHasLoadedActiveCustomerNames(true);
        } catch (error) {
            console.error(error);
            setActiveCustomerNames([]);
            setHasLoadedActiveCustomerNames(false);
        }
    };

    useEffect(() => {
        if (!window.sessionStorage.getItem("auth") || !hasReadPermission) {
            navigate('/unauthorized')
        }

        if (editedRecord !== null) {
            fetchSingleClientData(records[editedRecord].id);
            setEditedRecord(null)
        }
        else {
            if (shouldFilterByCustomer) {
                // user is a customer type - only access to their own customer data
                // pull only clients associated with this customer
                fetchCustomerClientData();
                // Pull the customer data for the associated customer
                fetchCustomerData();
            }
            else {
                // user is a higher admin - pull all clients
                fetchAllClientData();
            }

            if (canShowCustomerFilter) {
                fetchActiveCustomerNames();
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function handleHeaderClick(header) {
        if (!fieldsNoSort.includes(header.LABEL)) {
            const nextDirection =
                header.KEY === sort.keyToSort
                    ? (sort.direction === 'asc' ? 'desc' : 'asc')
                    : 'asc';

            const nextSort = {
                keyToSort: header.KEY,
                direction: nextDirection,
            };

            setSort(nextSort);
            setRecords((originalRecords) => {
                const sortedData = [...originalRecords].sort((a, b) => {
                    const getSortableValue = (record) => {
                        if (nextSort.keyToSort === 'customer_display') {
                            return record.customer_display || getCustomerDisplayFromRecord(record);
                        }

                        return record[nextSort.keyToSort];
                    };

                    const aValue = getSortableValue(a);
                    const bValue = getSortableValue(b);

                    if (aValue === null || aValue === undefined) return 1;
                    if (bValue === null || bValue === undefined) return -1;

                    const aComparable = String(aValue).toLowerCase();
                    const bComparable = String(bValue).toLowerCase();

                    if (nextSort.direction === 'asc') {
                        return aComparable.localeCompare(bComparable);
                    }

                    return bComparable.localeCompare(aComparable);
                });

                return sortedData;
            });
        }
    }

    const handleClientEdit = (clientInfo, recordIndex) => {
        // edit client info icon clicked
        // set default client customer in case one is not associated
        clientInfo['customer_name'] = 'None'
        clientInfo['customer_id'] = 99
        // set the record in order to do a refresh on the edited customer
        setEditedRecord(recordIndex)
        setClientEdit(clientInfo)
        setIsNewClient(false);
        setIsReadOnlyModal(false);
        setModalOpen(true);
      };

    const handleClientView = (clientInfo, event) => {
        if (event.target.closest('.actions-cell') || event.target.closest('.info-cell')) {
            return;
        }

        setClientEdit(clientInfo);
        setIsNewClient(false);
        setIsReadOnlyModal(true);
        setModalOpen(true);
    };

    const handleViewSessions = (clientInfo, options = {}) => {
        const { returnToModal = false, isReadOnly = false } = options;

        // View Sessions icon clicked
        setIsNewClient(false);
        setClientInfo(clientInfo);
        setClientIdSessions(clientInfo.id);
        if (returnToModal) {
            setSessionsReturnContext({
                client: clientInfo,
                isReadOnly,
            });
        } else {
            setSessionsReturnContext(null);
        }
        setModalSessionsOpen(true);
    }

    const closeSessionsModal = () => {
        setModalSessionsOpen(false);

        if (sessionsReturnContext?.client) {
            setClientEdit(sessionsReturnContext.client);
            setIsNewClient(false);
            setIsReadOnlyModal(!!sessionsReturnContext.isReadOnly);
            setModalOpen(true);
        }

        setSessionsReturnContext(null);
    }

    const handleViewNotes = (clientInfo) => {
        // Notes icon clicked
        setIsNewClient(false);
        setClientInfo(clientInfo);
        setModalNotes(true);
    }

    const handleDeleteClient = (clientInfo, recordIndex) => {
        // Delete icon clicked: open custom dialog to confirm deactivate
        if (canDeleteRecords) {
            setDeactivateClientInfo(clientInfo);
            setDeactivateRecordIndex(recordIndex);
            setModalDeactivateOpen(true);
        }
    }

    const closeDeactivateModal = () => {
        if (!isDeactivating) {
            setModalDeactivateOpen(false);
            setDeactivateClientInfo(null);
            setDeactivateRecordIndex(null);
        }
    }

    const confirmDeactivateClient = async () => {
        if (deactivateClientInfo === null || deactivateRecordIndex === null) {
            return;
        }

        setIsDeactivating(true);

        try {
            const response = await fetch(process.env.REACT_APP_API_URL_BASE + '/clients/client/' + deactivateClientInfo.id,
                {
                    method: 'PATCH',
                    headers: {
                        'machine':'2',
                        'vh-key':'7df7f81e-aaff-444c-a01c-8caeaeab3e61',
                        'content-type': 'application/json'
                    },
                    body: JSON.stringify({
                        is_active: false
                    }),
                });

            if (!response.ok) {
                throw new Error(`Failed to set client inactive. Status: ${response.status}`);
            }

            setRecords((originalRecords) => originalRecords.map((record, index) => {
                if (index !== deactivateRecordIndex) {
                    return record;
                }

                return {
                    ...record,
                    is_active: false
                };
            }));

            closeDeactivateModal();
        } catch (error) {
            console.error(error);
        } finally {
            setIsDeactivating(false);
        }
    }

    const handleNewClient = () => {
        // new client button clicked - create a generic empty client object
        const assignedCustomerId = Number(tokenCustomerId);
        const hasAssignedCustomer = Number.isInteger(assignedCustomerId) && assignedCustomerId > 0;

        const newClient = {
                'first_name': '',
                'last_name': '',
                'email': '',
                'mobile': '',
                'pin': '',
                'is_active': true,
                'dosage': 100,
                'steady_only': false,
                'music_type': 0,
                'customer_name': '',
                'customer_id': hasAssignedCustomer ? assignedCustomerId : 99,
                'play_audio_frequency': false
            };
        // if user is customer associated then only create clients for that customer
        if (shouldFilterByCustomer && customerInfo) {
            newClient['customer_name'] = customerInfo['customer_name'];
            newClient['customer_id'] = customerInfo['customer_id'];
        }

        if (!newClient['customer_name'] && hasAssignedCustomer && customerInfo && Number(customerInfo['customer_id']) === assignedCustomerId) {
            newClient['customer_name'] = customerInfo['customer_name'];
        }

        setClientEdit(newClient);
        setIsNewClient(true);
        setModalOpen(true);
      }

    const handleEditSubmit = (newRow) => {
        if (isNewClient) {
            // pull all data - refresh page
            window.location.reload()
            setIsNewClient(false)
        }
        else {
            // edited existing client - update specific row
            fetchSingleClientData(records[editedRecord].id)
            setEditedRecord(null)
        }
      }

    const handleNotesSubmit = () => {
        //  handle any necessary logic after a new has been added
    }

    const showDelete = (record, recordIndex) => {
        // if the user has delete scope then show the delete icon
        if (canDeleteRecords) {
            return <BsFillTrashFill onClick={() => handleDeleteClient(record, recordIndex)} className='delete-btn' title='Remove this Client' aria-label='Remove this Client'/>
        }
    }

    const showEdit = (record, recordIndex) => {
        // if the user has edit scope then show the edit icon
        if (canEditRecords) {
            return <BsFillPencilFill onClick={() => handleClientEdit(record,recordIndex)} className='edit-btn' title='Edit Client' aria-label='Edit Client'/>
        }
    }

    const hasNotesPermission = (tokenPayload.scopes || []).some((scope) =>
        scope.startsWith('create:clientNotes') || scope.startsWith('update:clientNotes')
    );

    const canDeleteRecords =
        (tokenPayload.scopes || []).some((scope) => scope.startsWith('delete:' + permissionScope));

    const canEditRecords =
        (tokenPayload.scopes || []).some((scope) => scope.startsWith('update:' + permissionScope)) ||
        (tokenPayload.scopes || []).some((scope) => scope.startsWith('create:' + permissionScope));

    const canShowAnyActions = canDeleteRecords || canEditRecords;
    const visibleHeaders = canShowAnyActions ? headers : headers.filter((header) => header.KEY !== 'actions');
    const canShowRemovedToggle = canDeleteRecords;

    const showCreateNew = () => {
        // if the user has create scope then show the Add New Client button
        if ((tokenPayload.scopes || []).some((scope) => scope.startsWith('create:' + permissionScope))) {
            return (
                <Link className='btn clients-add-btn' onClick={() => handleNewClient()}>+ Add New Client</Link>
            )
        }
    }

    function showDebug() {
        // var debugString = 'Sort Direction: ' + sort.direction + ' Sort Field: ' + sort.keyToSort;
        // // var debugString = sort.keyToSort === 'last_name' ? sort.direction : "asc"
        // return debugString
    }

    return (
        <div className='table-wrapper clients-page'>
            {/*<h3 className='left'>&emsp;&ensp;Clients{customerInfo !== null ? ": " + customerInfo.customer_name : ""} ({records.length})</h3>*/}
            <h3 className='page-title'>
                Clients <span className='page-count'>{visibleRecords.length}</span>
            </h3>
            <div>
                {showDebug()}
            </div>
            <div>
                {showCreateNew()}
            </div>
            <div className='clients-filter'>
                <div className='table-search-input-wrap'>
                    <input
                        type='text'
                        className='clients-search-input table-search-input'
                        value={searchText}
                        onChange={(event) => setSearchText(event.target.value)}
                        placeholder='Search clients'
                        aria-label='Search clients'
                    />
                    <button
                        type='button'
                        className='table-search-clear-icon'
                        onClick={() => setSearchText('')}
                        disabled={!searchText}
                        aria-label='Clear client search'
                    >
                        x
                    </button>
                </div>
                {canShowCustomerFilter && (
                    <label className='clients-customer-filter-wrap'>
                        <span className='clients-customer-filter-title'>Customer Filter</span>
                        <select
                            className='clients-customer-filter-select'
                            value={selectedCustomerFilter}
                            onChange={(event) => setSelectedCustomerFilter(event.target.value)}
                            aria-label='Filter clients by customer'
                        >
                            {customerFilterOptions.map((option) => (
                                <option key={option.value} value={option.value}>{option.label}</option>
                            ))}
                        </select>
                    </label>
                )}
                {canShowRemovedToggle && (
                    <label className='clients-filter-label'>
                        <input
                            type='checkbox'
                            checked={showActive}
                            onChange={(event) => setShowActive(event.target.checked)}
                        />
                        Show Removed
                    </label>
                )}
            </div>
            <font size="3">
            <table className='table'>
                <thead>
                    <tr>
                        {visibleHeaders.map((header, index) => (
                            <th key={index} className={header.CLASS} onClick={() => handleHeaderClick(header)}>
                                {header.LABEL}
                                {header.KEY === sort.keyToSort && (
                                <Caret direction={sort.keyToSort === header.KEY ? sort.direction : "asc"}/>)}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {
                        isTableLoading ? (
                            Array.from({ length: 6 }).map((_, rowIndex) => (
                                <tr key={`clients-skeleton-${rowIndex}`} className='table-skeleton-row'>
                                    {visibleHeaders.map((header, cellIndex) => (
                                        <td key={`clients-skeleton-${rowIndex}-${header.KEY}-${cellIndex}`}>
                                            <span className={`table-skeleton-line${header.KEY === 'info' || header.KEY === 'actions' ? ' short' : ''}`} />
                                        </td>
                                    ))}
                                </tr>
                            ))
                        ) : (
                            visibleRecords.map(({ record, recordIndex }) => {
                                return <tr key={recordIndex} onClick={(event) => handleClientView(record, event)}>
                                <td className='info-cell'>
                                    <span className='actions'>
                                        {hasNotesPermission && (
                                            <BsFileTextFill onClick={(event) => { event.stopPropagation(); handleViewNotes(record); }} className='sessions-btn' title='Client Notes' aria-label='Client Notes'/>
                                        )}
                                        <BsTable onClick={(event) => { event.stopPropagation(); handleViewSessions(record); }} className='sessions-btn' title='Show Session History' aria-label='Show Session History'/>
                                    </span>
                                </td>
                                <td className='left'>{record.first_name}</td>
                                <td className='left'>{record.last_name}</td>
                                <td className='left'>{record.mobile}</td>
                                <td className='center'>{record.pin.replaceAll(/./g,"*")}</td>
                                <td className='center'>{record.customer_display}</td>
                                <td className='center'>{record.is_active ? "\u2714" : ""}</td>
                                <td className='center'>{record.steady_only ? "\u2714" : ""}</td>
                                <td className='left'>{format(new Date(record.last_updated), 'MMM d, yyyy h:mm a')}</td>
                                <td className='left'>{format(new Date(record.created_on), 'MMM d, yyyy')}</td>
                                {canShowAnyActions && (
                                    <td className='actions-cell'>
                                        <span className='actions'>
                                            {showEdit(record, recordIndex)}
                                            {showDelete(record, recordIndex)}
                                        </span>
                                    </td>
                                )}
                            </tr>
                            })
                        )}
                </tbody>
            </table>
            </font>
            {modalOpen && <ModalWide closeModal={() => {
                setModalOpen(false)
                setIsReadOnlyModal(false)
            }}
                onSubmit={handleEditSubmit}
                clientEdit={clientEdit}
                isNewClient={isNewClient}
                isReadOnly={isReadOnlyModal}
                onOpenTreatmentHistory={(client) => {
                    setModalOpen(false);
                    handleViewSessions(client, {
                        returnToModal: true,
                        isReadOnly: isReadOnlyModal,
                    });
                }}
                onOpenTreatmentNotes={(client) => {
                    setModalOpen(false);
                    setIsReadOnlyModal(false);
                    handleViewNotes(client);
                }}
            />}
            {modalSessionsOpen && <ModalSessions closeModal={closeSessionsModal}
                clientIdSessions={clientIdSessions}
                isNewClient={isNewClient}
                clientInfo={clientInfo}
            />}
            {modalNotes && <ModalNotes closeModal={() => {
                setModalNotes(false)
            }}
                onSubmit={handleNotesSubmit}
                clientInfo={clientInfo}
                isNewClient={isNewClient}
            />}
            {modalDeactivateOpen && deactivateClientInfo && <ModalDeactivateClient
                closeModal={closeDeactivateModal}
                onConfirm={confirmDeactivateClient}
                clientInfo={deactivateClientInfo}
                isSubmitting={isDeactivating}
            />}
        </div>
  )
}

export default Clients



